import { render, staticRenderFns } from "./DeliveryPortfolioAll.vue?vue&type=template&id=d9a47aca&scoped=true"
import script from "./DeliveryPortfolioAll.vue?vue&type=script&lang=js"
export * from "./DeliveryPortfolioAll.vue?vue&type=script&lang=js"
import style0 from "./DeliveryPortfolioAll.vue?vue&type=style&index=0&id=d9a47aca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a47aca",
  null
  
)

export default component.exports